
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimbel/slot-selection",
      function () {
        return require("private-next-pages/bimbel/slot-selection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimbel/slot-selection"])
      });
    }
  